import React from 'react';
import ReactDOM from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { DatesProvider } from '@mantine/dates';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { queryClient, persistOptions } from './lib/queryPersistence';
import App from './App.tsx';
import { theme } from './theme';
import { initGA4, isSharePath } from './utils/analytics';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import './styles/globals.css';

// Initialize GA4 (only in production or if explicitly enabled), never when the
// first page is a share link: GA would send its token as page_location (design 8.1).
if ((import.meta.env.PROD || import.meta.env.VITE_GA4_ID) && !isSharePath(window.location.pathname)) {
  initGA4();
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MantineProvider theme={theme}>
      <ModalsProvider>
        <Notifications />
        <DatesProvider settings={{}}>
          <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
            <App />
          </PersistQueryClientProvider>
        </DatesProvider>
      </ModalsProvider>
    </MantineProvider>
  </React.StrictMode>
);